<aside class="sidebar-shell-wrapper border d-flex flex-column justify-content-between position-relative overflow-hidden">

  <!-- BRAND HEADER -->
  <div class="sidebar-header d-flex align-items-center gap-3">
    <SidebarBrand
      :logo="logo"
      :title="brand_title"
      :subtitle="brand_subtitle"
      @brand-click="$emit('brand-click')"
    />

    <!-- 🔴 MOBILE CLOSE ACTION -->
    <slot name="sidebar-header-actions"></slot>
  </div>

  <hr class="border-bottom border-white border mt-0">

  <!-- ========== SCROLL AREA ========== -->
  <div class="sidebar-scroll-area flex-grow-1 overflow-auto overflow-x-hidden">

    <!-- CONTEXT BLOCK -->
    <slot name="context"></slot>

    <hr class="border-bottom border-white border mb-0">

    <!-- MENU BLOCK -->
    <slot name="menu"></slot>

    <!-- AFTER MENU BLOCK -->
    <slot name="after-menu"></slot>

  </div>

  <!-- ========== FOOTER (USER INFO) ========== -->
  <SidebarUserFooter
    :initials="initials"
    :full_name="full_name"
    :is_admin="is_admin"
  />

</aside>
